<template>
  <div v-if="hideDisclaimerText === false">
    <div v-if="geoLocationStatus" v-html="disclaimerText"></div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-storelocator-privacy-text',
  props: {
    disclaimerText: {
      type: String,
      required: true,
    },
    hideDisclaimerText: {
      type: Boolean,
      default: false,
    },
    geoLocationControl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      geoLocation: this.geoLocationControl,
      geoLocationStatus: false,
    };
  },
  created() {
    eventBus.on('Rfp-Geo-Location-Status', (val) => {
      this.validateCondition(val);
    });
    this.validateCondition(navigator.geolocation && window.google ? true : false);
  },
  methods: {
    validateCondition(val) {
      if (this.geoLocationControl === true) {
        this.geoLocationStatus = val;
      } else {
        this.geoLocationStatus = true;
      }
    },
  },
};
</script>
